"use client";

import { createContext, useContext, useState, useCallback, type ReactNode } from "react";
import { type Lang, t as translate } from "./translations";

interface LanguageContextValue {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: (key: string) => string;
}

const LanguageContext = createContext<LanguageContextValue>({
  lang: "ru",
  setLang: () => {},
  t: (key: string) => key,
});

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Lang>("ru");

  const setLang = useCallback((next: Lang) => {
    setLangState(next);
  }, []);

  const tt = useCallback(
    (key: string) => translate(lang, key),
    [lang],
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: tt }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
